import { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * Wrap any marketing/public route in this provider to opt-in
 * to the Instantly-inspired marketing theme. Tokens are scoped
 * to `.marketing-theme` so the authenticated app stays Atrium.
 */
export const MarketingThemeProvider = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => (
  <div className={cn("marketing-theme min-h-screen", className)}>
    {children}
  </div>
);
